import { PagedRequestDto } from './../paged-request.model';
export interface CorporateAdminSearchDto extends PagedRequestDto {
  corporationId?: string;
  isActive?: boolean | null;
  isTerminated?: boolean | null;
  locationId?: string | null; // Guid
}
